import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ModalOptions, ModalService, ToastType } from '@indice/ng-components';
import { MakeOfferModalComponent } from './make-offer-modal/make-offer-modal.component';
import { RequestWalkthroughModalComponent } from 'src/app/shared/components/request-walkthrough-modal/request-walkthrough-modal.coponent';
import { PropertyDetails } from 'src/app/services/portal-api.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { RequestCallbackModalComponent } from 'src/app/shared/components/request-callback-modal/request-callback-modal.component';
import { ToasterService } from 'src/app/services/toaster.service';
import { User } from 'oidc-client-ts';
import { tap } from 'rxjs';
import { ExpertsCallbackComponent } from "../../../shared/components/experts-callback/experts-callback.component";
import { RouterLink } from '@angular/router';
import { TooltipDirective } from 'src/app/shared/directives/tooltip.directive';
import { RequestsUnauthorizedComponent } from 'src/app/shared/components/requests-unauthorized/requests-unauthorized.component';
import { UnauthorizedRequestsTranslationSuffix } from '../../../shared/components/requests-unauthorized/requests-unauthorized.component';
import { LanguageRouterLinkDirective } from 'src/app/shared/directives/language-router-link.directive';

@Component({
  selector: 'app-aside-content',
  standalone: true,
  templateUrl: './aside-content.component.html',
  imports: [CommonModule, TranslocoDirective,LanguageRouterLinkDirective, ExpertsCallbackComponent, RouterLink, TooltipDirective],
})
export class AsideContentComponent {
  @Input() property: PropertyDetails | undefined;
  public isOpen: boolean = false;
  private currentUser: User | null;
  protected isAuctioned: boolean = false;
  private unauthorizedSuffix:UnauthorizedRequestsTranslationSuffix = UnauthorizedRequestsTranslationSuffix.MAKE_OFFER;
  toastTranslations:any
  constructor(
    private _authService: AuthService,
    private _modalService: ModalService,
    private _translate : TranslocoService,
    @Inject(ToasterService) private _toastService: ToasterService
  ) {
    this.currentUser = this._authService.getCurrentUser();
    this._translate.selectTranslateObject('toast-workflows-messages').pipe(
      tap((translations) => {
        this.toastTranslations = translations;
      })
    ).subscribe();
  }
  ngOnInit() {
    this.isAuctioned = !!(this.property?.auctionRounds && this.property?.auctionRounds.rounds?.length && this.property?.auctionRounds.rounds.length > 0)
  }
  public toggleAside() {
    this.isOpen = !this.isOpen;
  }

  protected onAskTourClick(): void {
    const modal = this._modalService.show(RequestWalkthroughModalComponent, {
      keyboard: true,
      class:  this.currentUser !== null ? 'max-h-dvh md:h-auto max-w-[657px]' : 'md:h-auto',
      initialState: {
        property: this.property,
        isLoggedIn:  this.currentUser !== null,
      },
    });
    modal.onHidden?.pipe(
      tap((r: any) => {
        let input = r.result as IAsideModalResponse;
        if (input.success != undefined) {
          if (input.success == true) {
            this._toastService.showBanner(ToastType.Success, this.toastTranslations?.walkthrough?.success?.title, undefined, 10000);
          } else {
            this._toastService.showBanner(ToastType.Error, this.toastTranslations?.walkthrough?.error?.title, input.errorDesc, 10000);
          }
        }
      })
    ).subscribe();
  }

  protected onMakeOfferClick(): void {
    if (!this.currentUser) {
      const modal =this._modalService.show(RequestsUnauthorizedComponent, {
        keyboard: true,
        class: 'h-dvh md:h-auto',
        initialState: {
          suffix: this.unauthorizedSuffix,
          imgSrc: '/assets/img/services.png'
        },
      });

      modal.onHidden?.subscribe()
    } else {
      const modal = this._modalService.show(MakeOfferModalComponent, {
        keyboard: true,
        class: 'max-h-dvh md:h-auto max-w-[657px]',
        initialState: {
          askingPrice: this.property?.price,
          propertyId: this.property?.id,
          isLoggedIn: this.currentUser !== null,
          propertyTitle: this.property?.title,
          propertyCode: this.property?.code
        },
      });
      modal.onHidden?.pipe(
        tap((r: any) => {
          let input = r.result as IAsideModalResponse;
          if (input.success != undefined) {
            if (input.success == true) {
              this._toastService.showBanner(ToastType.Success, this.toastTranslations?.offer?.success?.title, undefined, 10000);
            } else {
              this._toastService.showBanner(ToastType.Error, this.toastTranslations?.offer?.error?.title, input.errorDesc, 10000);
            }
          }
        })
      ).subscribe();
    }
  }
  public onCallbackClick() {
    const modal = this._modalService.show(RequestCallbackModalComponent, {
      keyboard: true,
      class:  this.currentUser !== null ? 'h-dvh md:h-auto' : 'md:h-auto',
      initialState: {
        property: this.property,
        isLoggedIn:  this.currentUser !== null,
      },
    });
    modal.onHidden?.pipe(
      tap((t: any) => {
        let input = t.result as IAsideModalResponse;
        if (input.success != undefined) {
          if (input.success == true) {
            this._toastService.showBanner(
              ToastType.Success,
              this.toastTranslations?.callback?.success?.title,
              (this.toastTranslations?.callback?.success?.title as string)
              .replace('{{fullName}}', this.property?.brokerName ?? '')
              .replace('{{phoneNumber}}', this.currentUser?.profile?.phone_number ?? '')
            )
          } else {
            this._toastService.showBanner(ToastType.Error, this.toastTranslations?.callback?.success?.title, input.errorDesc, 10000);
          }
        }
      })
    ).subscribe();
  }
}

export interface IAsideModalResponse {
  success?: boolean,
  errorDesc?: string,
}
